module.exports = __webpack_public_path__ + "static/media/main@2x.a7662acc.png";